module.exports = __webpack_public_path__ + "static/media/gtt-thewall-3.08e6d792.svg";